import React from "react";

import { VERTICAL_NAME } from "constants/config";
import { DetailDisplay } from "widgets";

import styles from "./MultipleUsers.module.scss";

const MultipleUsers = (props) => {
const { customerDetails, handleOnSelectUser } = props;

return (
  <div className={styles.mainContainer}>
    <div className={styles.stickyHeader}>
      Multiple accounts found against the entered phone number. Please choose an
      account to create order.
    </div>
    {customerDetails &&
      customerDetails.map((customer, index) => (
        <div
          className={styles.userInfoCard}
          key={customer.uamId}
          onClick={() =>
            handleOnSelectUser(customer.uamId, customer.verticalId)
          }
        >
          <DetailDisplay
            title="Name"
            value={
              !(customer.firstName || customer.lastName)
                ? "NA"
                : customer.firstName + " " + customer.lastName
            }
          />
          <DetailDisplay title="User Id" value={customer.uamId} />
          <DetailDisplay
            title="Business Vertical"
            value={VERTICAL_NAME[customer.verticalId]}
          />
        </div>
      ))}
  </div>
);
}

export default MultipleUsers;
